import React from "react";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { useAppSelector } from "@src/store/hooks";
import { X } from "lucide-react";
import styles from "./BulkSchedulePrice.module.scss";
import helperStyles from "@src/components/helpers.module.scss";
import { clx } from "../utils/stringUtils";
import { formatCurrency } from "../utils/numberUtils";

type TBulkSchedulePriceItem = {
	data: EventInventoryRecord;
	startPrice: string;
	endPrice: string;
	dateFrom: string;
	dateTo: string;
	onRemove?: (listingId: number) => void;
};

const priceLabel = (value: string): string => {
	const n = parseFloat(value);
	return value.trim() !== "" && !isNaN(n) ? formatCurrency(n) : "—";
};

const BulkSchedulePriceItem = ({ data, startPrice, endPrice, dateFrom, dateTo, onRemove }: TBulkSchedulePriceItem) => {
	const selectionEvent = useAppSelector((state) => state.pricing.selection.event);

	const itemAny = data as EventInventoryRecord & { Event_Headliner?: string; Event_Name?: string };
	const eventName = itemAny.Event_Headliner ?? itemAny.Event_Name ?? selectionEvent?.Event_Headliner ?? "";

	return (
		<div className={styles.singleListing}>
			<div className={styles.eventCol}>
				<div className={styles.secRowSeatCont}>
					<div style={{ userSelect: "none" }} className={clx(styles.itemTextPrimary, helperStyles.ellipsisDiv)}>
						{eventName}
					</div>
					<div className={styles.itemTextPrimary}>
						{data.Section}, Row {data.Row}
					</div>
					<div style={{ gap: "2px 8px" }} className={clx(styles.textSecondary, helperStyles.flexSmallGap)}>
						<div>ID: {data.Listing_ID}</div>
						{data.Seats ? <div>Seat {data.Seats}</div> : null}
					</div>
					{dateFrom ? <div className={styles.textSecondary}>Date from: {dateFrom}</div> : null}
					{dateTo ? <div className={styles.textSecondary}>Date to: {dateTo}</div> : null}
				</div>
			</div>
			<div className={clx(styles.qty, helperStyles.ellipsisDiv)}>{data.Quantity}</div>
			<div className={clx(styles.priceCol, styles.currentPriceValue)}>{formatCurrency(data.Item_Price ?? 0)}</div>
			<div className={styles.priceCol}>
				<span className={styles.priceChip}>{priceLabel(startPrice)}</span>
			</div>
			<div className={styles.priceCol}>
				<span className={styles.priceChip}>{priceLabel(endPrice)}</span>
			</div>
			<div onClick={() => onRemove?.(data.Listing_ID)} className={styles.xContainer}>
				<div>
					<X size={16} />
				</div>
			</div>
		</div>
	);
};

export default BulkSchedulePriceItem;
